import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import UserLogin from './modules/UserLogin' // 登录页面
import Common from './modules/Common' // 通用接口
import Statistics from './modules/Statistics'
import Unit from './modules/Unit'
import Permission from './modules/Permission'
import Operation from './modules/Operation'
import SpaceManagement from './modules/SpaceManagement'
import UserManagement from './modules/UserManagement'
import OnlineOrder from './modules/OnlineOrder'

const state = {
  leftMenuShow:true,
  leftMenuIndex:0,
  // rem
  fontSize:10,
  // 初始日期
  fromDate:"2021-01-01"
}

const mutations = {
  SET_LEFTMENU_SHOW(state, value) {
    state.leftMenuShow = value;
  },
  SET_LEFTMENU_INDEX(state, value) {
    state.leftMenuIndex = value;
  }
}

const store = new Vuex.Store({
  modules: {
    UserLogin,
    Common,
    Statistics,
    Unit,
    Permission,
    Operation,
    SpaceManagement,
    UserManagement,
    OnlineOrder
  },
  state,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js